import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RolesService extends BaseService{

  constructor(protected http: HttpClient) {
    super(http);
  }

  getList(): Observable<IRole[]> {
    let url = 'Admin/GetRoles';
    return this.get(url, {});
  }

  getDepartments(): Observable<ICompany[]> {
    let url = 'Admin/GetCompanies';
    return this.get(url, {});
  }

  getWidgets(): Observable<IWidget[]> {
    let url = 'Admin/GetWidgets';
    return this.get(url, {});
  }

  createRole(obj: IRole) {
    let url = 'Admin/CreateRole';
    return this.post(url, obj);
  }

  updateRole(obj: IRole) {
    let url = 'Admin/UpdateRole';
    return this.post(url, obj);
  }

}

export interface IRole {
  id?: number;
  name: string;
  description: string;
  widgets?: [];
}

export interface ICompany {
  id: number;
  title: string;
  departments: IDepartment[];
}

export interface IDepartment {
  id: number;
  title: string;
}

export interface IWidget {
  id: number;
  title: string;
  letter: string;
}
